import Control from "./Control.js"

export default class JumpBack extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-jump-back", true)
    this.state.altText = "MSG_JUMP_BACK"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onClick() {
    const player = this.player
    if (player.playState === "playing" || player.playState === "paused") {
      this.player.currentTime = Math.max(this.player.currentTime - 10, 0)
    }
    else if (player.ended === true) {
      this.player.replay()
    }
  }

}
